export default __webpack_public_path__ + "static/media/hht2_ep09_timeline_q02_b.b946157e.png";